const ESTADO_DE_MEXICO_DISPLAY_NAME = 'Estado de México'

export function getStateDisplayName(name: string | null | undefined): string {
  if (!name) return ''
  return name === 'México' ? ESTADO_DE_MEXICO_DISPLAY_NAME : name
}

